import { realApi } from './api';

// El selector «Aplazar en nombre de» entrega el id como texto, y los POST de la API exigen un número.
const idJugador = (jugadorId) => (jugadorId ? Number(jugadorId) : undefined);

// Todo /yo/* cuelga de la sesión; sin jugador vinculado responde 403 SIN_JUGADOR.
// `jugadorId` (solo ADMIN/COMITE): ver y gestionar los aplazamientos de otro jugador.
export const getAplazamientos = (temporada, jugadorId) => {
  const params = new URLSearchParams();
  if (temporada) params.set('temporada', temporada);
  if (jugadorId) params.set('jugadorId', jugadorId);
  const qs = params.toString();
  return realApi.get(qs ? `/yo/aplazamientos?${qs}` : '/yo/aplazamientos').then((r) => r.datos);
};

// justificante: { nombre, tipo, contenido (base64) } o null. Sin marcha atrás:
// el partido pasa a APLAZADO (o, si admite WO o hay justificante, queda solo la
// solicitud: con justificante la revisa el comité y no corre plazo hasta entonces).
export const solicitarAplazamiento = ({ partidoId, admiteWo, tieneJustificante, justificante, jugadorId }) =>
  realApi
    .post('/yo/aplazamientos', {
      partidoId, admiteWo, tieneJustificante, justificante: tieneJustificante ? justificante : null,
      jugadorId: idJugador(jugadorId),
    })
    .then((r) => r.datos);

// Puntos de un aplazado recuperado; queda PROPUESTO hasta que lo confirme el comité.
export const informarPuntosAplazado = (partidoId, { sets, fechaJugado, jugadorId }) =>
  realApi.post(`/yo/aplazamientos/${partidoId}/resultado`, {
    sets, fechaJugado: fechaJugado || undefined, jugadorId: idJugador(jugadorId),
  });
